import { observer } from 'mobx-react-lite';
import { UnitConverterUI } from '../features/unit-converter/ui/unit-converter-ui';

export const UnitConverterObserver = observer(() => {
  return <UnitConverterUI />;
});
